import { GoogleDeviceStatus } from '@cdw-ae/common-data';
import { NavigationConfig, UrlStateItem } from '@cdw-ae/url-params';
import { REPORT_TYPES } from '../reports.model';

/**
 * Navigation configuration for reports page
 * Defines how clicking report cards navigates to report-viewer with filters
 */
export const ReportsNavigationConfig: NavigationConfig<UrlStateItem>[] = [
  {
    identifier: REPORT_TYPES.MODEL_AUE,
    targetRoute: '/report-viewer/model-aue',
    targetFilterBarId: 'reportFilters',
    filterMappings: [
      {
        clickedValue: 'default',
        filters: [
          {
            field: 'status',
            operator: 'equals',
            value: GoogleDeviceStatus.ACTIVE,
          },
        ],
      },
    ],
  },
  {
    identifier: REPORT_TYPES.CHROME_VERSION_AGE,
    targetRoute: '/report-viewer/chrome-version-age',
    targetFilterBarId: 'reportFilters',
    filterMappings: [
      {
        clickedValue: 'default',
        filters: [
          {
            field: 'status',
            operator: 'equals',
            value: GoogleDeviceStatus.ACTIVE,
          },
        ],
      },
    ],
  },
  {
    identifier: REPORT_TYPES.BATTERY_HEALTH,
    targetRoute: '/report-viewer/battery-health',
    targetFilterBarId: 'reportFilters',
    filterMappings: [
      {
        clickedValue: 'default',
        filters: [
          {
            field: 'status',
            operator: 'equals',
            value: GoogleDeviceStatus.ACTIVE,
          },
        ],
      },
    ],
  },
  {
    identifier: REPORT_TYPES.STORAGE_BY_OU,
    targetRoute: '/report-viewer/storage-by-ou',
    targetFilterBarId: 'reportFilters',
    filterMappings: [
      {
        clickedValue: 'default',
        filters: [
          {
            field: 'status',
            operator: 'equals',
            value: GoogleDeviceStatus.ACTIVE,
          },
        ],
      },
    ],
  },
  {
    identifier: REPORT_TYPES.FIFTEEN_DAY_ACTIVITY,
    targetRoute: '/report-viewer/fifteen-day-activity',
    targetFilterBarId: 'reportFilters',
    filterMappings: [
      {
        clickedValue: 'default',
        filters: [
          {
            field: 'status',
            operator: 'equals',
            value: GoogleDeviceStatus.ACTIVE,
          },
        ],
      },
    ],
  },
];
